/**
 * An angular wrapper for JCrop
 */
angular.module('qkr').directive('jcrop', ($rootScope) => function(scope, element) {
    let ratio = $rootScope.requiredAspectRatio;

    function showCoords(scope, c) {
        scope.crop.x = c.x;
        scope.crop.y = c.y;
        scope.crop.x2 = c.x2;
        scope.crop.y2 = c.y2;
        scope.crop.w = c.w;
        scope.crop.h = c.h;
    }

    let jcrop_api;
    // Trying to dynamically change the aspect ratio
    $rootScope.$watch('requiredAspectRatio', () => {
        try {
            ratio = $rootScope.requiredAspectRatio;
            if (typeof (jcrop_api) !== 'undefined') {
                jcrop_api.setOptions({
                    aspectRatio: ratio  // 1.3 for example
                });
            }
        } catch (e) {
        }
    });
    $rootScope.$on('initialiseJCrop', (evt, args) => {
        try {
            if (typeof (jcrop_api) !== 'undefined') {
                jcrop_api.setSelect([0, 0, 2000, 2000]); // Making it large by default seems to automatically sort
                    // the max size
            }
        } catch (e) {
        }
    });
    $rootScope.$on('clearJCrop', (evt, args) => {
        try {
            if (typeof (jcrop_api) !== 'undefined') {
                jcrop_api.destroy();
            }

            $(element[0]).css('height', '');
            $(element[0]).attr('style', '');
        } catch (e) {
        }
    });

    $(element[0]).on('load', () => {
        $(() => {
            $(element[0]).Jcrop({
                    // BoxWidth: 450,
                    onChange(c) {
                        showCoords(scope, c);
                    },
                    onSelect(c) {
                        showCoords(scope, c);
                    },
                    setSelect: [0, 0, 2000, 2000], // Making it large by default seems to automatically sort
                    // the max size
                    aspectRatio: ratio
                }, function() {
                    jcrop_api = this;
                }
            );
        });
    });
});



// WEBPACK FOOTER //
// ./src/directives/jcrop.js